<form
  (submit)="onSubmit($event)"
  class="modal-content border-0 shadow-lg animate-fade-in"
>
  <!-- Header -->
  <div
    class="modal-header border-bottom px-4 py-3 d-flex align-items-center justify-content-between"
  >
    <h5 class="modal-title fw-bold text-dark fs-6">
      {{ 'CHANGE_PASSWORD.TITLE' | translate }}
    </h5>
    <button
      type="button"
      class="btn-close shadow-none"
      (click)="activeModal.dismiss()"
      aria-label="Close"
    ></button>
  </div>

  <!-- Body -->
  <div class="modal-body px-4 py-3">
    <fieldset [disabled]="isBusy()" class="border-0 p-0 m-0">
      <!-- Hidden username field for accessibility/password managers -->
      <input
        type="text"
        [value]="userName()"
        autocomplete="username"
        hidden
        readonly
      />

      <app-password-field
        fieldId="old_password"
        label="CHANGE_PASSWORD.OLD_PASSWORD"
        placeholder="CHANGE_PASSWORD.PLACEHOLDER_OLD"
        [field]="changePasswordForm.old_password"
        wrapperClass="mb-3"
        autocomplete="current-password"
      />

      <app-password-field
        fieldId="new_password"
        label="CHANGE_PASSWORD.NEW_PASSWORD"
        placeholder="CHANGE_PASSWORD.PLACEHOLDER_NEW"
        [field]="changePasswordForm.new_password"
        wrapperClass="mb-3"
        autocomplete="new-password"
      />

      <app-password-field
        fieldId="confirm_password"
        label="CHANGE_PASSWORD.CONFIRM_PASSWORD"
        placeholder="CHANGE_PASSWORD.PLACEHOLDER_CONFIRM"
        [field]="changePasswordForm.confirm_password"
        wrapperClass="mb-0"
        autocomplete="new-password"
      />
    </fieldset>
  </div>

  <!-- Footer -->
  <div
    class="modal-footer border-top p-3 px-4 d-flex justify-content-end gap-2"
  >
    <button
      type="button"
      class="btn btn-outline-secondary px-4 py-2 fw-medium rounded"
      (click)="activeModal.dismiss()"
    >
      {{ 'COMMON.CLOSE' | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary px-4 py-2 fw-bold text-white d-flex align-items-center gap-2 rounded shadow-sm"
      [disabled]="isBusy() || changePasswordForm().invalid()"
    >
      @if (isBusy()) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        <svg lucideSave [size]="18"></svg>
      }
      {{ 'COMMON.SAVE' | translate }}
    </button>
  </div>
</form>
